/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./iconList.vue?vue&type=template&id=37389334&scoped=true&"
import script from "./iconList.vue?vue&type=script&lang=js&"
export * from "./iconList.vue?vue&type=script&lang=js&"
import style0 from "./iconList.vue?vue&type=style&index=0&id=37389334&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37389334",
  null
  
)

export default component.exports